export enum TreatPreferences {
  PeanutButter = 'PeanutButter',
  MilkBones = 'MilkBones',
  Chicken = 'Chicken',
  DoesNotLikeTreats = 'DoesNotLikeTreats',
}
